import React from "react";

// ============================================================
// Group Highlights — Content for Homepage.pdf, Slide 10
// ============================================================
const highlights = [
  { num: "10+", label: "Specialized Companies" },
  { num: "5", label: "Strategic Initiatives" },
  { num: "100+", label: "Digital Projects Delivered" },
  { num: "50+", label: "Business Partners & Clients" },
  { num: "1000+", label: "Professionals & Learners Impacted" },
  { num: "AI", label: "AI-Driven Technology Solutions" },
  { num: "1", label: "Startup & Innovation Ecosystem" },
  { num: "Global", label: "Strategic Collaborations" },
];

const GroupHighlights: React.FC = () => {
  return (
    <section className="highlights pb-150">
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-50">
          <span className="sub-title mb-15">Group Highlights</span>
          <h2 className="title">The KOT universe in numbers</h2>
        </div>

        <div className="row mt-none-30">
          {highlights.map((item, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6 mt-30" key={index}>
              <div
                className="xb-hlstat wow fadeInUp"
                data-wow-delay={`${(index % 4) * 100}ms`}
                data-wow-duration="600ms"
              >
                <span className="xb-hlstat--num">{item.num}</span>
                <span className="xb-hlstat--label">{item.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GroupHighlights;
